module.exports = __webpack_public_path__ + "static/fonts/Metric-R-bold.b7d13e4.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/metric/Metric-R-bold.woff2
// module id = daJU
// module chunks = 28